/**
 * Registration payload builder.
 *
 * Assembles the web registration payload from the app-side
 * parameters (product `app_name`, env-major `app_identifier`, workspace
 * `app_version`, app-minted `device_id`) plus the shared device metadata.
 * `platform` is always `'Web'` for this lib's consumers.
 */
import { getDeviceMetadata } from './device-metadata';
import type { WebPushRegistrationPayload } from './fcm-api';

export interface BuildWebPushRegistrationPayloadOptions {
  token: string;
  /** Product routing axis (backend `fcm_routing`) — e.g. `'one'`, `'sms'`. */
  appName: string;
  /** Env-major Firebase Web App entry display name (ADR-132 A4 §3). */
  appIdentifier: string;
  /** Workspace-root package version (injected app-side). */
  appVersion: string;
  /** App-minted device id (single-owner storage-key rule). */
  deviceId: string;
}

export function buildWebPushRegistrationPayload(
  options: BuildWebPushRegistrationPayloadOptions,
): WebPushRegistrationPayload {
  const meta = getDeviceMetadata();
  return {
    token: options.token,
    platform: 'Web',
    app_name: options.appName,
    app_identifier: options.appIdentifier,
    app_version: options.appVersion,
    device_id: options.deviceId,
    device_model: meta.browser,
    os_version: meta.os,
    locale: meta.locale,
    timezone: meta.timezone,
    screen_resolution: meta.screenResolution,
  };
}
